/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CreateApplicationCheckStatus {
  Moderation = 'moderation',
  FullCheck = 'full_check',
}

export function instanceOfCreateApplicationCheckStatus(value: any): boolean {
  for (const key in CreateApplicationCheckStatus) {
    if (
      Object.prototype.hasOwnProperty.call(CreateApplicationCheckStatus, key)
    ) {
      if (
        CreateApplicationCheckStatus[
          key as keyof typeof CreateApplicationCheckStatus
        ] === value
      ) {
        return true
      }
    }
  }
  return false
}

export function CreateApplicationCheckStatusFromJSON(
  json: any
): CreateApplicationCheckStatus {
  return CreateApplicationCheckStatusFromJSONTyped(json, false)
}

export function CreateApplicationCheckStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateApplicationCheckStatus {
  return json as CreateApplicationCheckStatus
}

export function CreateApplicationCheckStatusToJSON(
  value?: CreateApplicationCheckStatus | null
): any {
  return value as any
}
